module.exports = __webpack_public_path__ + "img/wraning_plc.8ec9180f.svg";